<template>
  <div class="mine">
    <div class="title">
      <van-nav-bar title="我的" />
    </div>
    <div class="infoBox">
      <div class="infoImg">{{ substr(employeeInfo.name) }}</div>
      <div>
        <div>{{ employeeInfo.name }}</div>
        <div class="smSize">账号：{{ employeeInfo.loginName }}</div>
        <div class="smSize">药店：{{ drugstoreName }}</div>
      </div>
    </div>
    <div class="marginTop">
      <div v-online-click="jumpToPremanage">
        <van-cell title="处方记录" is-link>
          <van-icon
            slot="icon"
            :name="require('@/icons/premanage.png')"
            style="line-height: inherit;margin-right:10px"
          />
        </van-cell>
      </div>
    </div>
    <div class="marginTop">
      <div v-online-click="jumpToPwd">
        <van-cell title="修改密码" is-link>
          <van-icon
            slot="icon"
            :name="require('@/icons/resetPwd.png')"
            style="line-height: inherit;margin-right:10px"
          />
        </van-cell>
      </div>
      <div v-online-click="showActionSheet" v-if="showPhone">
        <van-cell title="联系客服" is-link value="400-050-7788">
          <van-icon slot="icon" name="phone-o" style="line-height: inherit;margin-right:10px" />
        </van-cell>
      </div>
      <!-- <div v-online-click="jumpToFaq" v-if="showService">
        <van-cell title="在线客服" is-link>
          <van-icon
            slot="icon"
            :name="require('@/icons/online-service.png')"
            style="line-height: inherit;margin-right:10px"
          />
        </van-cell>
      </div> -->
      <div v-online-click="jumpToUs">
        <van-cell title="关于我们" is-link>
          <van-icon
            slot="icon"
            :name="require('@/icons/aboutUs.png')"
            style="line-height: inherit;margin-right:10px"
          />
        </van-cell>
      </div>
      <div v-online-click="jumpToService">
        <van-cell title="服务协议" is-link>
          <van-icon
            slot="icon"
            :name="require('@/icons/service.png')"
            style="line-height: inherit;margin-right:10px"
          />
        </van-cell>
      </div>
    </div>
    <div v-online-click="logOut" class="logout marginTop">退出登录</div>
    <BottomBar :active="bottomBarActive" />
    <van-action-sheet
      v-model="showAction"
      :actions="actions"
      cancel-text="取消"
      description="400-050-7788"
      close-on-click-action
      @select="toCall"
    />
  </div>
</template>
<script>
import { toast } from '../../components/Toast'
import BottomBar from '../../components/BottomBar'
import { Dialog, version } from 'vant'
import { getEmployeeInfo, logOut } from '../../api/index'
import { getCookie } from '../../utils/auth'

export default {
  components: { BottomBar },
  data() {
    return {
      bottomBarActive: 1,
      employeeId: '',
      organSign: getCookie('native_organSign'),
      employeeInfo: {},
      showAction: false,
      actions: [{ name: '呼叫' }],
      showPhone: false,
      showBottom: true,
      // showService: false,
      channel_key: ''
    }
  },
  created() {
    this.showPhone = this.version(130)
    // this.showService = this.version(131)
    // 获取本地存储的员工id，若无则调登出协议，重新登录
    const employeeId = this.db.getItem('employeeId')
    this.drugstoreName = this.db.getItem('drugstoreName')
    this.employeeId = employeeId

    if (!employeeId) {
      window.location.href = 'protocol://action/logout'
      this.db.removeItem('employeeId')
      this.db.removeItem('drugstoreName')
      return false
    }
    this.init()
  },
  methods: {
    isIos() {
      const u = navigator.userAgent
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
    version(num) {
      const appVersion = getCookie('native_version') || '1.0.0'
      const version = appVersion.split('.').join('')
      return parseInt(version) >= num
    },
    showActionSheet() {
      this.showAction = true
    },
    closeActionSheet() {
      this.showAction = false
    },
    // 获取我的信息
    init() {
      const { employeeId } = this
      getEmployeeInfo({ employeeId })
        .then(res => {
          this.employeeInfo = res
          this.channel_key = `药店:${getCookie(
            'native_drugstoreName'
          )} 机构:${getCookie('native_organSign')} 用户:${
            this.employeeInfo.loginName
          }`
        })
        .catch(res => {
          if (!toast) {
            toast(res.msg || res.result || res)
          }
        })
    },
    toCall(item) {
      if (item.name === '呼叫') {
        window.location.href = 'protocol://action/callPhone?tel=4000507788'
        this.showAction = false
      }
    },

    jumpToPremanage() {
      this.$router.push('premanage')
    },
    jumpToPwd() {
      this.$router.push('resetPassword')
    },
    jumpToUs() {
      this.$router.push('aboutUs')
    },
    jumpToService() {
      this.$router.push('service')
    },
    // 退出登录
    logOut() {
      const { employeeId, organSign } = this
      Dialog.confirm({
        title: '确认退出登录吗？',
        message: ''
      })
        .then(() => {
          // 确认
          logOut({ employeeId, organSign })
            .then(res => {
              if (res == true) {
                window.location.href = 'protocol://action/logout'
                this.db.removeItem('employeeId')
                this.db.removeItem('drugstoreName')
              }
            })
            .catch(res => {
              if (!toast) {
                toast(res.msg || res.result || res)
              }
            })
        })
        .catch(() => {
          // 取消
        })
    },

    // 头像显示截取
    substr(str) {
      if (!str) return ''
      return str.substr(str.length - 2, 2)
    }
  }
}
</script>
<style scoped>
@import '../../styles/search.css';
#app {
  height: 100vh;
}
.title {
  height: 64px;
}
.mine /deep/.van-nav-bar {
  height: 64px;
  line-height: 64px;
}
.mine .van-hairline--bottom::after {
  border: none;
}
.mine {
  width: 375px;
  height: 100vh;
  background: #f7f7f7;
  position: relative;
}
.infoBox {
  display: flex;
  align-items: center;
  font-size: 14px;
  background: #fff;
  padding: 15px;
}
.infoImg {
  width: 50px;
  height: 50px;
  background: #3d7eff;
  text-align: center;
  line-height: 50px;
  border-radius: 50%;
  margin-right: 15px;
  color: #fff;
}
.infoBox img {
  width: 50px;
  height: 50px;
  background: #3d7eff;
  border-radius: 50%;
  margin-right: 15px;
}
.infoBox .smSize {
  color: #666;
  font-size: 12px;
}
.marginTop {
  margin-top: 10px;
  font-size: 14px;
}
.logout {
  width: 100%;
  background: white;
  text-align: center;
  color: red;
  font-size: 14px;
  padding: 10px 0;
}
.call {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #323233;
  font-size: 16px;
  padding-bottom: 10px;
}
.van-icon,
.van-icon::before {
  color: rgb(192, 192, 192);
}
</style>
